export default "__VITE_ASSET__dac357cb__"